// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store'; // The central Redux store

// --- STYLESHEET IMPORTS ---
// 1. Base styles and CSS variables (must come first)
import './index.css';
// 2. Component-specific styles (replaces styles.css and the old App.css)
import './App.css';

import App from './App';

// Get the root element from the HTML file
const rootElement = document.getElementById('root');

// Create a React root for concurrent rendering
const root = ReactDOM.createRoot(rootElement);

// Render the entire application
root.render(
  <React.StrictMode>
    {/* The Provider makes the Redux store available to all components */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .catch(() => { }); // Silently fail if registration fails
  });
}